import { CircularProgress } from "@mui/material";
import React from "react";
import "./LoadingScreen.css";

export default function LoadingScreen() {
  return <CircularProgress className="loading-screen" />;
}
